module.exports = __webpack_public_path__ + "img/mourning-2.0a4ba07e.jpg";